import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-product-card-shimmer',
    templateUrl: './product-card-shimmer.component.html',
    styleUrls: ['./product-card-shimmer.component.scss'],
    standalone: false
})
export class ProductCardShimmerComponent implements OnInit {

  @Input() cardType?: 'basic' | 'big' | 'list';

  constructor() { }

  ngOnInit(): void {
  }

}
